import { Link, useLocation } from 'react-router';
import { ThemePicker } from './ThemePicker';
import { UserMenu } from './UserMenu';

interface LayoutProps {
  children: React.ReactNode;
}

const NAV_ITEMS = [
  { path: '/jobs', label: 'Jobs' },
  { path: '/eval-sets', label: 'Eval Sets' },
  { path: '/samples', label: 'Samples' },
  { path: '/scans', label: 'Scans' },
  { path: '/usage', label: 'Usage' },
  { path: '/search', label: 'Transcript Search' },
];

export function Layout({ children }: LayoutProps) {
  const location = useLocation();

  return (
    <div className="h-screen flex flex-col overflow-hidden bg-surface dark:bg-gray-950">
      {/* Top Navigation Header */}
      <header className="shrink-0 px-5 py-2.5 shadow-sm bg-linear-to-br from-brand-600 to-brand-700 dark:from-brand-700 dark:to-ink-strong">
        <nav className="flex items-center justify-between">
          <div className="flex items-center gap-1">
            {NAV_ITEMS.map(item => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={
                    'px-4 py-2 text-sm font-medium rounded-md transition-all duration-150 no-underline ' +
                    (isActive
                      ? 'text-white bg-white/20 shadow-sm'
                      : 'text-white/70 hover:text-white')
                  }
                >
                  {item.label}
                </Link>
              );
            })}
          </div>
          <div className="flex items-center gap-2">
            <ThemePicker />
            <UserMenu />
          </div>
        </nav>
      </header>

      <main className="flex-1 overflow-hidden bg-white dark:bg-gray-900">
        {children}
      </main>
    </div>
  );
}
